/**
 * <strong>Purpose:</strong> <br>
 * Provides the ability to horizontally align the content .
 * <br><br>
 * <strong>Contract:</strong> <br>
 * <em>Attach-point:</em> alignmentNode - The node that the widget wishes to align within it's parent node.<br>
 * The widget using this should also mixin the SizeMixin since this only makes sense when the bounds of the
 * widget are larger than the content.
 *
 * @module mw-form/mixins/property/HorizontalAlignmentMixin
 *
 * @copyright Copyright 2014 The MathWorks, Inc.
 */

define([
    "dojo/_base/declare"
], function (declare) {
    //Add mwAlignmentNode class to the node in template which should be aligned horizontally
    var SUPPORTED_VALUES = ["left", "center", "right"],
        CLASS_NAME_PREFIX = "mwHorizontalAlignment",
        ALIGNMENT_CLASS_NAMES = {},
        capitalize = function (string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        };

    // Generate the ALIGNMENT_CLASS_NAMES object based on the SUPPORTED_VALUES
    // An example of a generated CSS class would look like: "mwHorizontalAlignmentRight"
    Object.keys(SUPPORTED_VALUES).forEach(function (index) {
        ALIGNMENT_CLASS_NAMES[SUPPORTED_VALUES[index]] =
            CLASS_NAME_PREFIX + capitalize(SUPPORTED_VALUES[index]);
    });

    return declare(null, {

        /**
         * @property  {string} horizontalAlignment - Supported Values: "left"/"center"/"right"
         * @instance
         * @default
         */
        horizontalAlignment: "center",

        postCreate: function () {
            this.inherited(arguments);
            this.domNode.classList.add("mwHorizontalAlignmentMixin");
        },

        _setHorizontalAlignmentAttr: function (horizontalAlignment) {

            if (SUPPORTED_VALUES.indexOf(horizontalAlignment) === -1) {
                throw new Error("'Vertical alignment' property expects '" +
                    "' one of these values: " + SUPPORTED_VALUES);
            }
            this._applyHorizontalAlignmentClass(horizontalAlignment);

            this._set("horizontalAlignment", horizontalAlignment);
        },


        _applyHorizontalAlignmentClass: function (alignment) {
            var oldAlignmentValue,
                classNameToRemove,
                classNameToAdd;
            oldAlignmentValue = this.get("horizontalAlignment");
            classNameToRemove = ALIGNMENT_CLASS_NAMES[oldAlignmentValue];
            // to prevent removal of ALL css class when this is passed during construction
            if (classNameToRemove) {
                this.domNode.classList.remove(classNameToRemove);
            }
            // Apply the new alignment CSS class
            classNameToAdd = ALIGNMENT_CLASS_NAMES[alignment];
            this.domNode.classList.add(classNameToAdd);
        }
    });

});
